import { render, staticRenderFns } from "./ResearchRegionPlotVector.vue?vue&type=template&id=1cc9551b"
import script from "./ResearchRegionPlotVector.vue?vue&type=script&lang=js"
export * from "./ResearchRegionPlotVector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cc9551b')) {
      api.createRecord('1cc9551b', component.options)
    } else {
      api.reload('1cc9551b', component.options)
    }
    module.hot.accept("./ResearchRegionPlotVector.vue?vue&type=template&id=1cc9551b", function () {
      api.rerender('1cc9551b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/vectorPlots/ResearchRegionPlotVector.vue"
export default component.exports